import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const VALIDATE_RSS_FEED_URL = registerQuery({
  fieldName: 'validation',
  args: ['url'],
  fetcher({
    url
  }) {
    return http.get('cosemail/v1/rssfeeds/validate', {
      query: {
        url
      }
    });
  }
});